<div class="right_login olvide_mi_clave">
	<div class="content_form">
		<h1>Olvido de contraseña / Desbloqueo de usuario</h1>
		<div class="tab-slider--container">
			<div class="usuario_contrasena" *ngIf="!showSucces">
				<p>No te preocupes, la puedes cambiar fácilmente.</p>
				<form [formGroup]="formGroup">
					<div class="form_row clearfix">
						<div class="form_step_pago form_cell" style="padding-bottom: 0px !important; margin-bottom: 18px">
							<label>Tipo de persona:</label>
							<select class="form_element" formControlName="personType" (change)="changePersonType()">
								<option *ngFor="let person of typePerson" [ngValue]="person">
									{{ person.name }}
								</option>
							</select>
						</div>
						<div class="form_cell">
							<label>{{ placeholder }}</label>
							<span class="user_dni_codigo">
								<input
									numeric
									class="form_element"
									[ngClass]="{ val_error: validInputForm('partnerNumber') }"
									type="text"
									formControlName="partnerNumber"
									[maxlength]="11"
									[placeholder]="'Ingrese ' + placeholder"
									autocomplete="off"
								/>
							</span>
							<app-valid-message-form
								*ngIf="validInputForm('partnerNumber')"
								[message]="messageErrorPartnerNumber"
								type="error"
							></app-valid-message-form>
						</div>
						<ng-container *ngIf="showBirthdateInput">
							<div class="form_cell">
								<label>Ingrese su fecha de nacimiento:</label>
								<span class="user_dni_codigo">
									<input
										type="date"
										[ngClass]="{ val_error: validInputForm('birthdate') }"
										formControlName="birthdate"
										class="form_element icon_calendario"
									/>
								</span>
								<app-valid-message-form
									*ngIf="validInputForm('birthdate')"
									[message]="messageErrorBirthdate"
									type="error"
								></app-valid-message-form>
							</div>
						</ng-container>
					</div>
				</form>
				<!--<label class="error" *ngIf="showMessageErrorUserCode">*El usuario no existe</label>-->
				<div class="center_content">
					<button
						class="boton_ingresar enviar_clave"
						[ngClass]="{ disabled: !formGroup.valid }"
						(click)="clickEnviar()"
					>
						ENVIAR
					</button>
				</div>
				<div class="center_content">
					<a [routerLink]="['/login']" class="volver_enviar">Regresar al login</a>
				</div>
				<!--
				<app-alert
					title="Importante"
					message="Si olvidaste tu código de socio, por favor comunícate vía WhatsApp al número: <br/><b><a class='no_icon volver_enviar' href ='https://wa.me/51937482907' target='_blank'>(+51)937-482-907</a></b>"
					type="warn"
				></app-alert>
				-->
			</div>

			<div class="revisar_correo" *ngIf="showSucces">
				<app-alert
					title="¡Listo!"
					message="Te enviamos un correo con todos los detalles para el cambio de contraseña."
					type="succes"
				>
				</app-alert>

				<div class="center_content no_recibi_correo">
					<p>No recibí el correo electrónico</p>
					<a (click)="showSucces = false" class="volver_enviar">Volver a Enviar</a>
				</div>

				<div class="center_content">
					<!-- <a routerLinkActive="router-link-active" class="boton_ingresar button">VOLVER AL INICIO</a> -->
					<a [routerLink]="['/login']" class="boton_ingresar button">VOLVER AL INICIO</a>
				</div>
			</div>
		</div>
	</div>
</div>
